<template>
  <v-tooltip top content-class="restricted-tooltip-content">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item
        v-bind="{ ...$attrs, ...attrs }"
        v-on="{ ...$listeners, ...on }"
        class="restricted-menu-list-item"
      >
        <v-list-item-icon v-if="icon">
          <v-icon>{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content style="min-width: 0">
          <v-list-item-title>
            {{ text }}
            <v-icon v-if="pinned" small color="primary" class="ml-1" style="float: right;">mdi-pin</v-icon>
          </v-list-item-title>
        </v-list-item-content>
        <slot></slot>
      </v-list-item>
    </template>
    <span>{{ tooltip_text }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'RestrictedMenuListItem',
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    tooltip_text: {
      type: String,
      default: 'Staff Only'
    },
    pinned: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.restricted-menu-list-item {
  position: relative;
  border-left: 3px solid #e53935 !important;
}

::v-deep .restricted-tooltip-content {
  background-color: #e53935 !important;
  color: white !important;
}
</style>
